var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("h1", [_vm._v("Opportunities")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-download",
              attrs: { href: _vm.downloadURL },
            },
            [_vm._v("Download All")]
          ),
          _vm._v(" "),
          _vm.can("createOpportunities")
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: { to: "/opportunities/create" },
                },
                [_vm._v("\n\t\t\t\tCreate\n\t\t\t")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filters" },
        [
          _c("FormControlSector", {
            attrs: {
              name: "sectors",
              multiple: true,
              "include-ancestors": false,
            },
            model: {
              value: _vm.sectors,
              callback: function ($$v) {
                _vm.sectors = $$v
              },
              expression: "sectors",
            },
          }),
          _vm._v(" "),
          _c("FormControlDealType", {
            attrs: { name: "dealType", "allow-empty": true },
            model: {
              value: _vm.filters.deal_type,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "deal_type", $$v)
              },
              expression: "filters.deal_type",
            },
          }),
          _vm._v(" "),
          _c("FormControlMember", {
            attrs: {
              name: "member",
              "allow-empty": true,
              placeholder: "Select...",
              label: "Member company",
            },
            model: {
              value: _vm.filters.member,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "member", $$v)
              },
              expression: "filters.member",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "fromDate", label: "From date" },
            model: {
              value: _vm.filters.fromDate,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "fromDate", $$v)
              },
              expression: "filters.fromDate",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "toDate", label: "To date" },
            model: {
              value: _vm.filters.toDate,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "toDate", $$v)
              },
              expression: "filters.toDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form__group search",
          attrs: { slot: "search" },
          slot: "search",
        },
        [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "local-search" } },
            [_vm._v("Search Opportunities")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.query,
                expression: "filters.query",
              },
            ],
            staticClass: "form__control search",
            attrs: {
              id: "local-search",
              type: "search",
              placeholder: "Filter by title",
            },
            domProps: { value: _vm.filters.query },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filters, "query", $event.target.value)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "all", title: "All Opportunities" } },
            [
              _c("ListOpportunities", {
                ref: "all",
                attrs: { "load-on-start": false, filters: _vm.filteredFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "mine", title: "My Opportunities" } },
            [
              _c("ListOpportunities", {
                ref: "mine",
                attrs: {
                  "load-on-start": false,
                  filters: _vm.filteredFilters,
                  "mine-only": true,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }